import React from 'react';
import { Check } from 'lucide-react';
import styles from './SugarSachetHero.module.css';

const SugarSachetHero = ({
  badge,
  scriptTitle,
  mainTitleLines,
  kicker,
  descriptions,
  features,
  imagePrimary,
  imageSecondary,
}) => (
  <section className={styles.heroSection}>
    <div className={styles.inner}>
      <div className={styles.layout}>
        <div className={styles.visualCol}>
          <div className={styles.spreadStage}>
            {imagePrimary && (
              <figure className={styles.heroSpread}>
                <img src={imagePrimary.src} alt={imagePrimary.alt} />
              </figure>
            )}

            {imageSecondary && (
              <figure className={styles.detailCard}>
                <img src={imageSecondary.src} alt={imageSecondary.alt} />
              </figure>
            )}

            <span className={styles.trayLine} aria-hidden="true" />
          </div>
        </div>

        <div className={styles.copyCol}>
          <span className={styles.badge}>{badge}</span>

          <div className={styles.titleBlock}>
            <span className={styles.eyebrow}>{scriptTitle}</span>
            <h1 className={styles.title}>
              {mainTitleLines[0]}{' '}
              <span className={styles.titleAccent}>{mainTitleLines[1]}</span>
            </h1>
            <span className={styles.titleRule} aria-hidden="true" />
          </div>

          {kicker && <p className={styles.kicker}>{kicker}</p>}

          <div className={styles.bodyCopy}>
            {descriptions.slice(0, 2).map((text, index) => (
              <p key={index} className={styles.paragraph}>
                {text}
              </p>
            ))}
          </div>

          {features?.length > 0 && (
            <ul className={styles.featureList}>
              {features.map((feature, index) => (
                <li key={index} className={styles.featureItem}>
                  <span className={styles.checkIcon}>
                    <Check size={11} strokeWidth={3} aria-hidden="true" />
                  </span>
                  <span>{feature}</span>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  </section>
);

export default SugarSachetHero;
